//
//
//
//
//
//
//
import { queryBigDataById, queryUrlBySiteId } from '@/api/api';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import water from "../dashboard/com/water.vue";
import water52 from '@/views/tenant/qd/dashboard/com/water.vue';
export default {
  mixins: [GetSiteIdMixin],
  components: {
    water: water,
    water52: water52
  },
  data: function data() {
    return {
      st: window.sessionStorage.getItem('siteType')
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.query.siteId) {
      var siteId = this.$route.query.siteId;
      var siteName = this.$route.query.siteName;
      var st = this.$route.query.st;
      this.resetSetItem('siteId', siteId);
      this.resetSetItem('siteName', siteName);
      this.resetSetItem('siteType', st);
      window.addEventListener('setItem', function (e) {
        if (e.key == 'siteType') {
          _this.st = window.sessionStorage.getItem('siteType');
        }
      });
    }
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var _this2 = this;

      var ids = this.getTreeCurrentId();

      if (ids[0] == 1) {
        queryBigDataById({
          id: value
        }).then(function (res) {
          setTimeout(function () {
            _this2.$refs.water.getType({
              siteId: ids[1],
              siteName: '',
              siteType: _this2.st
            }, res);
          }, 100);
        }).catch(function (e) {
          setTimeout(function () {
            _this2.$refs.water.getType({
              siteId: ids[1],
              siteName: '',
              siteType: _this2.st
            });
          }, 100);
        });
      }
    }
  }
};